[
  {
    "draftJersey": 213,
    "role": "PT",
    "name": "Eliott Mounoud",
    "foot": "right",
    "height": 188,
    "birthdate": "10/08/1995",
    "country": "Suiza",
    "macros": {
      "reflexes": 82,
      "diving": 87,
      "duels": 81,
      "passing": 80,
      "handling": 80,
      "anticipation": 82,
      "average": 82
    },
    "matchYtVideoId": "PhbZO3ABZI8",
    "profileYtVideoId": "47iTadSZNTM",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/322170550.png"
  },
  {
    "draftJersey": 216,
    "role": "PT",
    "name": "Hugo Eyre",
    "foot": "right",
    "height": 184,
    "birthdate": "07/05/1994",
    "country": "España",
    "macros": {
      "reflexes": 79,
      "diving": 86,
      "duels": 79,
      "passing": 78,
      "handling": 78,
      "anticipation": 79,
      "average": 79
    },
    "matchYtVideoId": "-K5grbzs_Tg",
    "profileYtVideoId": "UWMztQV4IMg",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/324328289.png"
  },
  {
    "draftJersey": 231,
    "role": "PT",
    "name": "Juan Sebastián Rodríguez",
    "foot": "right",
    "height": 174,
    "birthdate": "17/10/1990",
    "country": "Colombia",
    "macros": {
      "reflexes": 74,
      "diving": 86,
      "duels": 80,
      "passing": 66,
      "handling": 79,
      "anticipation": 78,
      "average": 78
    },
    "matchYtVideoId": "9mNB0j37rzc",
    "profileYtVideoId": "s9PLndJ6FaM",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/194663026.png"
  },
  {
    "draftJersey": 240,
    "role": "PT",
    "name": "Miguel Ángel De La Fuente",
    "foot": "right",
    "height": 176,
    "birthdate": "03/05/2002",
    "country": "España",
    "macros": {
      "reflexes": 78,
      "diving": 87,
      "duels": 79,
      "passing": 81,
      "handling": 82,
      "anticipation": 79,
      "average": 81
    },
    "matchYtVideoId": "9mNB0j37rzc",
    "profileYtVideoId": "Sbb-eXdKoDE",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/576551257.png"
  },
  {
    "draftJersey": 242,
    "role": "PT",
    "name": "Pol Agustí",
    "foot": "right",
    "height": 177,
    "birthdate": "22/05/1997",
    "country": "España",
    "macros": {
      "reflexes": 79,
      "diving": 83,
      "duels": 79,
      "passing": 79,
      "handling": 80,
      "anticipation": 79,
      "average": 80
    },
    "matchYtVideoId": "9mNB0j37rzc",
    "profileYtVideoId": "EiC0SizabjI",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/29429578.png"
  },
  {
    "draftJersey": 243,
    "role": "PT",
    "name": "Rafa Leva",
    "foot": "right",
    "height": 178,
    "birthdate": "27/09/1981",
    "country": "España",
    "macros": {
      "reflexes": 82,
      "diving": 87,
      "duels": 81,
      "passing": 87,
      "handling": 87,
      "anticipation": 82,
      "average": 82
    },
    "matchYtVideoId": "h7n8Nv-ybvA",
    "profileYtVideoId": "Ax_dyRcfdhE",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/67694011.png"
  },
  {
    "draftJersey": 246,
    "role": "PT",
    "name": "Yaroslav Toporkov",
    "foot": "right",
    "height": 191,
    "birthdate": "27/02/2001",
    "country": "Ucrania",
    "macros": {
      "reflexes": 86,
      "diving": 87,
      "duels": 78,
      "passing": 86,
      "handling": 86,
      "anticipation": 84,
      "average": 83
    },
    "matchYtVideoId": "h7n8Nv-ybvA",
    "profileYtVideoId": "rWFRN0JE63w",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/518803188.png"
  }
]